module.exports = __webpack_public_path__ + "static/sfv-match-19915050a27e69ae356f884d3a298111.png";